import RolesDesk4me from 'desk4me/Roles'
import RolesOrganization from 'organization/Roles'
import RolesFreeroom from 'freeroom/Roles'

var rolesByModule = {}

rolesByModule['desk4me'] = RolesDesk4me
rolesByModule['organization'] = RolesOrganization
rolesByModule['freeroom'] = RolesFreeroom

export default {
  rolesByModule,
  showRoute(module, menuRoute, clientRoles, clientAdmin){
    if(rolesByModule[module]){
      return rolesByModule[module].showRoute(menuRoute, clientRoles, clientAdmin)
    }
  },
  getResponsibleModule(route){
    if(route.includes('/desk4me/')){
      return 'desk4me'
    }
    if(route.includes('/freeroom/')){
      return 'freeroom'
    }
    if(route.includes('/organization/')){
      return 'organization'
    }
    return null
  }
}

